/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';

import {
  ElUserComponent,
} from './user.component';
import { ElBadgeModule } from '../badge/badge.module';

const EL_USER_COMPONENTS = [
  ElUserComponent,
];

@NgModule({
  imports: [
    ElSharedModule,
    ElBadgeModule,
  ],
  declarations: [
    ...EL_USER_COMPONENTS,
  ],
  exports: [
    ...EL_USER_COMPONENTS,
  ],
})
export class ElUserModule { }
